
const state = {
  Authorization: sessionStorage.getItem('token') ? sessionStorage.getItem('token') : '',
  userName: sessionStorage.getItem('userInfo') &&JSON.parse(sessionStorage.getItem('userInfo')).userInfo != undefined? JSON.parse(sessionStorage.getItem('userInfo')).userInfo.realname : ''
}
const mutations = {
  token (state, user) {
    state.Authorization = user.Authorization
    sessionStorage.setItem('token', user.Authorization);
  },
  user (state, user) {
    state.userName = user.userName

  }
}
export default {
  state,
  mutations
}
